export default __webpack_public_path__ + "static/media/saumyabhattresume.f2cc2af7.pdf";